export const dateFormat = 'YYYY-MM-DD'

export const legalBasisOptions = [
  { value: 'Consent', label: 'Consent' },
  { value: 'Contractual Necessity', label: 'Contractual Necessity' },
  { value: 'Legal Obligation', label: 'Legal Obligation' },
  { value: 'Legitimate Interests', label: 'Legitimate Interests' },
];

export const thirdPartyLegalBasisOptions = [
  { value: 'Adequacy Decision', label: 'Adequacy Decision' },
  { value: 'Standard Contractual Clauses (SCCs)', label: 'Standard Contractual Clauses (SCCs)' },
  { value: 'Binding Corporate Rules (BCRs)', label: 'Binding Corporate Rules (BCRs)' },
  { value: 'Explicit Consent', label: 'Explicit Consent' },
  { value: 'Special permission from supervisory authority', label: 'Special permission from supervisory authority' },
  { value: 'Other', label: 'Other' },
];

export const privacyOfficers = [
  {
    id: 'privacyOfficer',
    label: 'Privacy Officer',
  },
  {
    id: 'dataProtectionOfficer',
    label: 'Data Protection Officer',
  },
  {
    id: 'noPerson',
    label: 'No person, just use company contacts',
  },
]

export const isEUandEEACountryCodes = new Set([
  // ЕС  27
  'AT','BE','BG','HR','CY','CZ','DK','EE','FI',
  'FR','DE','GR','HU','IE','IT','LV','LT','LU',
  'MT','NL','PL','PT','RO','SK','SI','ES','SE',
  //EEA  3 
  'IS', 
  'LI', 
  'NO'  
]);

export const supervisoryAuthority = {
  "AT": {
    "name": "Austria",
    "authority": "\u00d6sterreichische Datenschutzbeh\u00f6rde",
    "link": "https://dsb.gv.at/eingabe-an-die-dsb/beschwerde"
  },
  "BE": {
    "name": "Belgium",
    "authority": "Autorit\u00e9 de la protection des donn\u00e9es / Gegevensbeschermingsautoriteit",
    "link": "https://www.autoriteprotectiondonnees.be/citoyen/l-autorite/autres-autorites"
  },
  "BG": {
    "name": "Bulgaria",
    "authority": "Commission for Personal Data Protection",
    "link": "https://cpdp.bg/en/lodging-complaints-and-alerts/"
  },
  "HR": {
    "name": "Croatia",
    "authority": "Croatian Personal Data Protection Agency",
    "link": "https://azop.hr/zahtjev-za-utvrdivanje-povrede-prava/"
  },
  "CY": {
    "name": "Cyprus",
    "authority": "Commissioner for Personal Data Protection",
    "link": "https://www.dataprotection.gov.cy/dataprotection/dataprotection.nsf/page1i_en/page1i_en?opendocument="
  },
  "CZ": {
    "name": "Czech Republic",
    "authority": "Office for Personal Data Protection (\u00daOO\u00da)",
    "link": "https://uoou.gov.cz/en/contact"
  },
  "DK": {
    "name": "Denmark",
    "authority": "Datatilsynet",
    "link": "https://www.datatilsynet.dk/english/file-a-complaint"
  },
  "EE": {
    "name": "Estonia",
    "authority": "Estonian Data Protection Inspectorate",
    "link": "http://www.aki.ee/"
  },
  "FI": {
    "name": "Finland",
    "authority": "Office of the Data Protection Ombudsman",
    "link": "http://www.tietosuoja.fi/en/"
  },
  "FR": {
    "name": "France",
    "authority": "Commission Nationale de l\u2019Informatique et des Libert\u00e9s (CNIL)",
    "link": "https://www.cnil.fr/en/plaintes"
  },
  "DE": {
    "name": "Germany",
    "authority": "Bundesbeauftragte f\u00fcr den Datenschutz und die Informationsfreiheit (BfDI)",
    "link": "https://www.bfdi.bund.de/anschriften"
  },
  "GR": {
    "name": "Greece",
    "authority": "Hellenic Data Protection Authority",
    "link": "http://www.dpa.gr/"
  },
  "HU": {
    "name": "Hungary",
    "authority": "National Authority for Data Protection and Freedom of Information (NAIH)",
    "link": "http://www.naih.hu/"
  },
  "IE": {
    "name": "Ireland",
    "authority": "Data Protection Commission",
    "link": "http://www.dataprotection.ie/"
  },
  "IT": {
    "name": "Italy",
    "authority": "Garante per la protezione dei dati personali",
    "link": "http://www.garanteprivacy.it/"
  },
  "LV": {
    "name": "Latvia",
    "authority": "Data State Inspectorate",
    "link": "https://www.dvi.gov.lv/"
  },
  "LT": {
    "name": "Lithuania",
    "authority": "State Data Protection Inspectorate",
    "link": "https://vdai.lrv.lt/lt/veiklos-sritys-1/skundu-nagrinejimas"
  },
  "LU": {
    "name": "Luxembourg",
    "authority": "Commission Nationale pour la Protection des Donn\u00e9es (CNPD)",
    "link": "http://www.cnpd.lu/"
  },
  "MT": {
    "name": "Malta",
    "authority": "Office of the Information and Data Protection Commissioner",
    "link": "http://www.idpc.org.mt/"
  },
  "NL": {
    "name": "Netherlands",
    "authority": "Autoriteit Persoonsgegevens",
    "link": "https://autoriteitpersoonsgegevens.nl/"
  },
  "PL": {
    "name": "Poland",
    "authority": "Personal Data Protection Office (UODO)",
    "link": "https://uodo.gov.pl/"
  },
  "PT": {
    "name": "Portugal",
    "authority": "Comiss\u00e3o Nacional de Prote\u00e7\u00e3o de Dados (CNPD)",
    "link": "http://www.cnpd.pt/"
  },
  "RO": {
    "name": "Romania",
    "authority": "National Supervisory Authority for Personal Data Processing (ANSPDCP)",
    "link": "http://www.dataprotection.ro/"
  },
  "SK": {
    "name": "Slovakia",
    "authority": "Office for Personal Data Protection of the Slovak Republic",
    "link": "http://www.dataprotection.gov.sk/"
  },
  "SI": {
    "name": "Slovenia",
    "authority": "Information Commissioner of the Republic of Slovenia",
    "link": "https://www.ip-rs.si/"
  },
  "ES": {
    "name": "Spain",
    "authority": "Agencia Espa\u00f1ola de Protecci\u00f3n de Datos (AEPD)",
    "link": "https://www.aepd.es/"
  },
  "SE": {
    "name": "Sweden",
    "authority": "Integritetsskyddsmyndigheten (IMY)",
    "link": "http://www.imy.se/"
  }, 
  "IS": {
    "name": "Iceland",
    "authority": "Persónuvernd (Data Protection Authority)",
    "link": "https://island.is/s/personuvernd/almennar-fyrirspurnir"
  },
  "LI": {
    "name": "Liechtenstein",
    "authority": "Datenschutzstelle (State Data Protection Inspectorate)",
    "link": "https://formulare.llv.li/formserver_DSS/start.do?generalid=DSS_BF&lang=en#"
  },
  "NO": {
    "name": "Norway",
    "authority": "Norwegian Data Protection Authority (Datatilsynet)",
    "link": "https://www.datatilsynet.no/en/about-us/contact-us/how-to-complain-to-the-norwegian-dpa/"
  }
};